import {
  ProDirectorySection,
  ProDirectorySectionLocation,
  ProDirectorySectionLocationDistance,
  ProDirectorySectionLocationDistanceValues,
} from '../types/pro-directory-page.types'
import {validateDatoCmsTypes} from './common.serde'
import {DynamicProDirectorySectionFieldsFragment} from '../../../../__generated__/datocms.types'

export function parseProDirectorySection(s: DynamicProDirectorySectionFieldsFragment): ProDirectorySection {
  const section = validateDatoCmsTypes(s)

  const location = parseProDirectionSectionLocation(section)
  const distance = parseProDirectorySectionDistance(section)
  return {
    __type: 'ProDirectorySection',
    id: section.id,
    title: section.title,
    plot: section.plot,
    description: section.description,
    offeringIds: section.offerings?.filter(i => !!i?.id).map(i => i!.id!.toString()),
    industryIds: section.industries
      ?.split(',')
      ?.filter(i => !!i)
      .map(i => i!),
    // merge location and distance as distance does not make sense without location
    location: location
      ? {
          ...location,
          distance,
        }
      : undefined,
  }
}

function parseProDirectionSectionLocation(
  fragment: Pick<DynamicProDirectorySectionFieldsFragment, 'location'>,
): ProDirectorySectionLocation | undefined {
  if (!fragment.location) {
    return undefined
  }
  // location is a single string with enforced "{zip} {postalDistrict}" format through validators
  const spaceIndex = fragment.location.indexOf(' ')
  const zipStr = fragment.location.substring(0, spaceIndex)
  const postalDistrict = fragment.location.substring(spaceIndex + 1)
  const zip = parseInt(zipStr)
  if (Number.isNaN(zip) || !postalDistrict) {
    return undefined
  }

  return {
    zip,
    postalDistrict,
  }
}

function parseProDirectorySectionDistance(
  fragment: Pick<DynamicProDirectorySectionFieldsFragment, 'distance'>,
): ProDirectorySectionLocationDistance | undefined {
  if (!fragment.distance) {
    return undefined
  }
  // convert minutes to meters (1min = 1000m = 1km)
  const scaledDistance = fragment.distance * 1000
  // the values should match the values implemented by the pro-directory component
  for (const d of ProDirectorySectionLocationDistanceValues) {
    if (d === scaledDistance) return scaledDistance
  }
  return undefined
}
